import { required, Validator } from '@/entities/validation';
import { Category } from './model';

export const validate: Validator<Category> = category => [
  ...required(category.title, 'title'),
];
